import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import CompanyLogDataTable from './CompanyLogDataTable';

const CompanyLogIndex = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);;
  return (
    <>
      <Row className="mt-4 mb-1">
        <Col>
          <h2 className="mt-3">Transacciones de Cambios</h2>
        </Col>
        <Col xs={12}>
          <h4 className="text-uppercase margin-fix mb-0">Historial de Acciones</h4>
        </Col>
      </Row>
      <CompanyLogDataTable />
    </>
  );
};

export default CompanyLogIndex;
